<template>
    <va-create-layout>
        <DebtRecoveryEventChargeInstrument-form
            :title="title"
            :item="item"
        ></DebtRecoveryEventChargeInstrument-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
